import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/5522999999999?text=Hello%2C%20let%27s%20chat%3F"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 bg-[#25D366] text-white rounded-full p-4 shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-200 flex items-center gap-2"
    >
      <MessageCircle size={24} />
      <span className="hidden md:inline text-sm font-medium">Hello, let's chat?</span>
    </a>
  );
};

export default WhatsAppButton;
